<div class="css-Boton_Primario-1 boton_primario">
    <button type="button" class="css-button_Icono_Izquierda_Secundario-1 button_icono_izquierda" [disabled]="disabled"
        [ngClass]="disabled ? 'btn-disabled' : ''" [class]="clase" (click)="ejecutarFuncion()" [title]="titulo">
        <!-- <div class="icono_consultenos">
            <img src="assets/images/basecomponents-images/icono-correo.svg" width="17.5px" height="15.833343505859px"
                data-wcfid="vector_forwardtoinbox" original-id="5236:14713" data-name="vector-forwardtoinbox"
                class="css-Vector_forward_to_inbox vector_forwardtoinbox">
        </div> -->
        <app-loader *ngIf="spinner == true"></app-loader>
        <p class="css-Texto_1-1 texto_1">{{boton_texto}}</p>
    </button>
    <p class="css-Estado-2 estado" *ngIf="estado">{{estado}}</p>
</div>